import { Box, Button, Grid, Typography } from '@mui/material'
import { Container } from '@mui/system'
import axiosInstance from 'custom-axios'
import { useFullPageLoader } from 'hooks/useFullPageLoader'
import React, { useEffect, useState } from 'react'
import Iframe from 'react-iframe'
import { useParams } from 'react-router'
import { ToastContainer, toast } from 'react-toastify'
import { getNextAllowedStep, getPreviousAllowedStep } from 'styles/commonFunction'

const RWMAgreement = ({ setActiveParentStep, activeParentStep }) => {

    const { id } = useParams();
    const [docuSignUrl, setDocuSignUrl] = useState();
    const [loader, showLoader, hideLoader] = useFullPageLoader();

    const loginType = localStorage.getItem('login_type');
    /**
     * FETCH THE SMART MONEY AGREEMENT FROM THE DOCUSIGN
     * @returns {Promise<void>}
     */
    const fetchSMIAgreement = async () => {
        showLoader();
        try {

            const response = await axiosInstance.get(`api/rwm-agreement/${id}`);
            // console.log(response);
            if (response.success) {
                setDocuSignUrl(response.smartMoneyAgreementUrl)
            } else {
                toast.error(response.message);
            }
            // hideLoader();
        } catch (error) {
            toast.error(error.message);
        } finally {
            hideLoader()
        }
    };

    const handleRoleBack = async () => {
        showLoader();

        const previousParentStep =
            getPreviousAllowedStep(activeParentStep);

        const endPoint = `api/change-form-step`;

        const submitData = {
            user_id: id,
            parent_step: previousParentStep,
            child_step: 0
        };

        try {
            const response = await axiosInstance.post(endPoint, submitData);

            if (response.status === 200) {
                setActiveParentStep(previousParentStep);
            }
        } catch (error) {
            toast.error('An error occurred when navigating back.');
        } finally {
            hideLoader();
        }
    };


    const handleNextStep = async () => {
        showLoader();

        const nextParentStep =
            getNextAllowedStep(activeParentStep);

        const endPoint = `api/change-form-step`;

        const submitData = {
            user_id: id,
            parent_step: nextParentStep,
            child_step: 0
        };

        try {
            const response = await axiosInstance.post(endPoint, submitData);

            if (response.status === 200) {
                setActiveParentStep(nextParentStep);
            }
        } catch (error) {
            toast.error('An error occurred when navigating next.');
        } finally {
            hideLoader();
        }
    };


    useEffect(() => {

        if (loginType == 'client') {
            fetchSMIAgreement()
        }

    }, []);

    return (
        <>
            <div className=''>
                {loginType == 'client' ?
                    <Box sx={{ height: '100vh', width: '100%', backgroundColor: '#ffffff', padding: '0 35px 35px 35px' }}>
                        {/* <div className='review-box-shadow'> */}

                        <Typography component="h2" variant="h2" align="center" color="text.primary" gutterBottom>
                            Raintree Wealth Management Agreement
                        </Typography>

                        <Iframe
                            id="smi-agreement-frame"
                            url={docuSignUrl}
                            title="Smart Money Agreement"
                            width="100%"
                            height="100%"
                            frameBorder="none"
                        />
                        {/* </div> */}

                        {/* <Grid item xs={12} sx={{ textAlign: 'center' }}>
                        <Button
                            id="btn-agreement"
                            variant="contained"
                            // color='#42a4b1'
                            // onClick={onClickContinue}
                            sx={{ backgroundColor: '#42a4b1' }}
                        >
                            CONTINUE
                        </Button>
                    </Grid> */}

                        <Grid item xs={12} sm={6} className='text-center'>
                            <Button variant='outlined' className='m-3' onClick={handleRoleBack}>
                                Back
                            </Button>
                            <Button variant='contained' className='m-3 raintree-btn-green' onClick={handleNextStep}>
                                Next
                            </Button>
                        </Grid>
                        {loader}
                        <ToastContainer />
                    </Box>
                    :

                    <Box sx={{
                        border: '2px solid #37a3b436',
                        padding: '10px',
                        marginTop: '30px',
                        marginBottom: '20px',
                        backgroundColor: '#37a3b436',
                        borderRadius: '8px'
                    }}>
                        <Typography
                            variant="body1"
                            component="div"
                            sx={{
                                fontSize: "14px",
                                color: "rgb(42 38 38)"
                            }}
                        >
                            Client has not singed the agreement yet.
                        </Typography>

                    </Box>
                }
            </div>
            {loader}
        </>
    )
}

export default RWMAgreement